import { useSelector } from "react-redux";
import { selectIsWarehouse, selectCanSwitchModules } from "../../store/slices/moduleSlice";
import ModuleTabs from "../../components/ModuleTabs";
import YardReport from "./YardReport";
import WarehouseReport from "./WarehouseReport";

const Report = () => {
  const isWarehouse = useSelector(selectIsWarehouse);
  const canSwitchModules = useSelector(selectCanSwitchModules);

  return (
    <div className="flex w-full h-screen overflow-y-scroll bg-gray-200">
      <div className="flex-1 p-8">
        {canSwitchModules && (
          <div className="mb-4">
            <ModuleTabs />
          </div>
        )}
        {isWarehouse ? <WarehouseReport /> : <YardReport />}
      </div>
    </div>
  );
};

export default Report;